module.exports = __webpack_public_path__ + "static/img/fish17.8a1d3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish17.png
// module id = EdCt
// module chunks = 0